import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { MapService } from '@app/map/map.service';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    LeafletModule
  ],
  declarations: [],
  providers:[MapService]
})
export class MapModule { }
